export default "__VITE_ASSET__d0a3d36d__"